export default __webpack_public_path__ + "static/media/0163.efa03108.jpg";